export default "__VITE_ASSET__CWrTX4Kh__"